// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import '../../Pages/RealtimeInferencingPageV3/style/index.css';
// import { APIClient } from '../../../helpers/apiHelper';
// import FeedSourceSelector from '../FeedSourceSelector';
// import { RotateCcw, X, Loader2 } from 'lucide-react';
// import { Modal } from '../../ComponnentsUI/common/Modal';

// // --- HELPER COMPONENTS ---
// const Button = ({
//   children,
//   onClick,
//   disabled = false,
//   variant = 'primary',
//   size = 'md',
//   className = '',
// }) => {
//   const baseClasses =
//     'inline-flex items-center justify-center rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
//   const variants = {
//     primary:
//       'bg-blue-600 dark:bg-blue-700 text-white hover:bg-blue-700 dark:hover:bg-blue-800 focus:ring-blue-500',
//     outline:
//       'border border-gray-300 dark:border-gray-600 bg-card-color-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 focus:ring-blue-500',
//   };
//   const sizes = {
//     sm: 'px-3 py-1.5 text-sm',
//     md: 'px-4 py-2 text-sm',
//     lg: 'px-6 py-3 text-base',
//   };
//   return (
//     <button
//       onClick={onClick}
//       disabled={disabled}
//       className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}
//     >
//       {children}
//     </button>
//   );
// };

// function StepperFeedRealtime({
//   inputDevices,
//   setDeviceId,
//   setInputDevices,
//   globalState,
//   setGlobalState,
//   mediaTypeSwitcher,
//   handleNext,
//   startVideoStream,
//   setShowDeviceModal,
//   showDeviceModal,
//   videoStream,
//   setVideoStream,
//   autoSelect = false,
//   resetOnOpen = false,
// }) {
//   const [newMachineName, setNewMachineName] = useState('');
//   const [isSaving, setIsSaving] = useState(false);
//   const [cropData, setCropData] = useState(null);
//   const [selectedFeedSource, setSelectedFeedSource] = useState(
//     'Select your feed source'
//   );
//   const [showFeedDropdown, setShowFeedDropdown] = useState(false);
//   const videoRef = useRef(null);
//   const videoContainerRef = useRef(null);
//   const apiClient = new APIClient();
//   const [isChecked, setIsChecked] = useState(true);
//   const [isAutoSelecting, setIsAutoSelecting] = useState(false);
//   const [autoSelectError, setAutoSelectError] = useState(null);
//   const hasAutoSelectedRef = useRef(false);

//   // Video overlay cropping state
//   const isDragging = useRef(false);
//   const isResizing = useRef(false);
//   const resizeHandle = useRef('');
//   const dragStart = useRef({ x: 0, y: 0 });
//   const [videoMetrics, setVideoMetrics] = useState(null);
//   const [cropBox, setCropBox] = useState({
//     x: 50,
//     y: 50,
//     width: 400,
//     height: 300,
//   });
//   const [isInteracting, setIsInteracting] = useState(false);
//   const resizeObserverRef = useRef(null);

//   const handleStartOver = () => {
//     setNewMachineName('');
//     setIsSaving(false);
//     setSelectedFeedSource('Select your feed source');
//     setCropData(null);
//     setCropBox({ x: 50, y: 50, width: 400, height: 300 });
//     setIsChecked(true);
//     setShowFeedDropdown(false);
//     setVideoMetrics(null);

//     if (videoStream) {
//       videoStream.getTracks().forEach((track) => track.stop());
//       setVideoStream(null);
//     }

//     refreshInputDevices();
//   };

//   useEffect(() => {
//     if (videoStream && videoRef.current) {
//       videoRef.current.srcObject = videoStream;
//     }
//   }, [videoStream]);

//   useEffect(() => {
//     if (showDeviceModal && resetOnOpen) {
//       setNewMachineName('');
//       setIsSaving(false);
//       setSelectedFeedSource('Select your feed source');
//       setCropData(null);
//       setCropBox({ x: 50, y: 50, width: 400, height: 300 });
//       setIsChecked(true);
//       setShowFeedDropdown(false);
//       setVideoMetrics(null);
//       hasAutoSelectedRef.current = true;

//       if (videoStream) {
//         videoStream.getTracks().forEach((track) => track.stop());
//         setVideoStream(null);
//       }
//     }
//   }, [showDeviceModal, resetOnOpen]);

//   useEffect(() => {
//     if (showDeviceModal) {
//       if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
//         navigator.mediaDevices
//           .getUserMedia({ video: true, audio: true })
//           .then((stream) => {
//             stream.getTracks().forEach((track) => track.stop());
//             return navigator.mediaDevices.enumerateDevices();
//           })
//           .then((devices) => {
//             setInputDevices(
//               devices.filter((device) => {
//                 const label = device.label.toLowerCase();
//                 // Exclude camera devices - keep capture cards and other video input devices
//                 const isCameraDevice =
//                   label.includes('camera') ||
//                   label.includes('webcam') ||
//                   label.includes('facetime') ||
//                   label.includes('integrated') ||
//                   label.includes('built-in') ||
//                   label.includes('front') ||
//                   label.includes('back') ||
//                   label.includes('selfie') ||
//                   label.includes('iphone') ||
//                   label.includes('ipad') ||
//                   label.includes('android');

//                 return device.kind === 'videoinput' && !isCameraDevice;
//               })
//             );
//           })
//           .catch((err) => setInputDevices([]));
//       }
//     }
//   }, [showDeviceModal, setInputDevices]);

//   useEffect(() => {
//     setGlobalState((prevState) => ({
//       ...prevState,
//       optionValueDevice: isChecked ? 'Share' : 'USB',
//     }));
//   }, [isChecked, setGlobalState]);

//   useEffect(() => {
//     if (
//       selectedFeedSource &&
//       selectedFeedSource !== FEED_SOURCE_PLACEHOLDER
//     ) {
//       setNewMachineName(selectedFeedSource);
//     }
//   }, [selectedFeedSource]);

//   const refreshInputDevices = async () => {
//     if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
//       try {
//         const stream = await navigator.mediaDevices.getUserMedia({
//           video: true,
//           audio: true,
//         });
//         stream.getTracks().forEach((track) => track.stop());

//         const devices = await navigator.mediaDevices.enumerateDevices();
//         const videoDevices = devices.filter((device) => {
//           const label = device.label.toLowerCase();
//           // Exclude camera devices - keep capture cards and other video input devices
//           const isCameraDevice =
//             label.includes('camera') ||
//             label.includes('webcam') ||
//             label.includes('facetime') ||
//             label.includes('integrated') ||
//             label.includes('built-in') ||
//             label.includes('front') ||
//             label.includes('back') ||
//             label.includes('selfie') ||
//             label.includes('iphone') ||
//             label.includes('ipad') ||
//             label.includes('android');

//           return device.kind === 'videoinput' && !isCameraDevice;
//         });
//         setInputDevices(videoDevices);
//       } catch (err) {
//         console.error('Failed to refresh input devices:', err);
//         setInputDevices([]);
//       }
//     }
//   };

//   const handleCheckboxChange = () => {
//     setIsChecked(!isChecked);
//     mediaTypeSwitcher();
//   };

//   const getEventCoordinates = useCallback(
//     (e: MouseEvent | TouchEvent | React.MouseEvent | React.TouchEvent) => {
//       if ('touches' in e && e.touches.length > 0) {
//         return { x: e.touches[0].clientX, y: e.touches[0].clientY };
//       } else if ('changedTouches' in e && e.changedTouches.length > 0) {
//         return {
//           x: e.changedTouches[0].clientX,
//           y: e.changedTouches[0].clientY,
//         };
//       } else if ('clientX' in e) {
//         return { x: e.clientX, y: e.clientY };
//       }
//       return { x: 0, y: 0 };
//     },
//     []
//   );

//   const handlePointerDown = useCallback(
//     (
//       e: MouseEvent | TouchEvent | React.MouseEvent | React.TouchEvent,
//       handle: string | null
//     ) => {
//       e.preventDefault();
//       e.stopPropagation();

//       setIsInteracting(true);

//       if (handle) {
//         isResizing.current = true;
//         resizeHandle.current = handle;
//       } else {
//         isDragging.current = true;
//       }

//       const coords = getEventCoordinates(e);
//       dragStart.current = {
//         x: coords.x,
//         y: coords.y,
//       };
//     },
//     [getEventCoordinates]
//   );

//   const handlePointerMove = useCallback(
//     (e: MouseEvent | TouchEvent) => {
//       if (!isDragging.current && !isResizing.current) return;
//       if (!videoContainerRef.current || !videoRef.current || !videoMetrics) {
//         return;
//       }

//       if ('touches' in e) {
//         e.preventDefault();
//       }

//       const video = videoRef.current;
//       const videoWidth = video.videoWidth;
//       const videoHeight = video.videoHeight;

//       // Calculate scale factor between rendered video and actual video dimensions
//       const scaleX = videoWidth / videoMetrics.renderedWidth;
//       const scaleY = videoHeight / videoMetrics.renderedHeight;

//       const coords = getEventCoordinates(e);
//       const deltaX = (coords.x - dragStart.current.x) * scaleX;
//       const deltaY = (coords.y - dragStart.current.y) * scaleY;

//       dragStart.current = { x: coords.x, y: coords.y };

//       const minSize = 50;

//       if (isDragging.current) {
//         // Dragging - move the crop box
//         setCropBox((prev) => {
//           const newX = Math.max(
//             0,
//             Math.min(prev.x + deltaX, videoWidth - prev.width)
//           );
//           const newY = Math.max(
//             0,
//             Math.min(prev.y + deltaY, videoHeight - prev.height)
//           );
//           return { ...prev, x: newX, y: newY };
//         });
//       } else if (isResizing.current) {
//         // Resizing - adjust crop box size with proper bounds
//         setCropBox((prev) => {
//           let { x, y, width, height } = prev;
//           const handle = resizeHandle.current;

//           // Store original positions to keep opposite edges fixed
//           const rightEdge = x + width;
//           const bottomEdge = y + height;

//           // East edge - only change width (left edge stays fixed)
//           if (handle === 'e' || handle.includes('e')) {
//             const newWidth = width + deltaX;
//             width = Math.max(minSize, Math.min(newWidth, videoWidth - x));
//           }

//           // West edge - only change x and width (right edge stays fixed)
//           if (handle === 'w' || handle.includes('w')) {
//             const newX = x + deltaX;
//             if (newX >= 0 && rightEdge - newX >= minSize) {
//               x = newX;
//               width = rightEdge - newX;
//             } else if (newX < 0) {
//               x = 0;
//               width = rightEdge;
//             } else {
//               // Hit minimum size - right edge stays fixed
//               x = rightEdge - minSize;
//               width = minSize;
//             }
//           }

//           // South edge - only change height (top edge stays fixed)
//           if (handle === 's' || handle.includes('s')) {
//             const newHeight = height + deltaY;
//             height = Math.max(minSize, Math.min(newHeight, videoHeight - y));
//           }

//           // North edge - only change y and height (bottom edge stays fixed)
//           if (handle === 'n' || handle.includes('n')) {
//             const newY = y + deltaY;
//             if (newY >= 0 && bottomEdge - newY >= minSize) {
//               y = newY;
//               height = bottomEdge - newY;
//             } else if (newY < 0) {
//               y = 0;
//               height = bottomEdge;
//             } else {
//               // Hit minimum size - bottom edge stays fixed
//               y = bottomEdge - minSize;
//               height = minSize;
//             }
//           }

//           // Final safety clamp to ensure we're within bounds
//           x = Math.max(0, Math.min(x, videoWidth - minSize));
//           y = Math.max(0, Math.min(y, videoHeight - minSize));
//           width = Math.max(minSize, Math.min(width, videoWidth - x));
//           height = Math.max(minSize, Math.min(height, videoHeight - y));

//           return { x, y, width, height };
//         });
//       }
//     },
//     [videoMetrics, getEventCoordinates]
//   );

//   const handlePointerUp = useCallback(() => {
//     isDragging.current = false;
//     isResizing.current = false;
//     resizeHandle.current = '';
//     setIsInteracting(false);
    
//     // Update crop data with current crop box values
//     setCropBox((currentCropBox) => {
//       const newCropData = {
//         x: Math.round(currentCropBox.x),
//         y: Math.round(currentCropBox.y),
//         width: Math.round(currentCropBox.width),
//         height: Math.round(currentCropBox.height),
//       };
//       setCropData(newCropData);
//       return currentCropBox;
//     });
//   }, []);

//   useEffect(() => {
//     if (showDeviceModal && videoStream) {
//       // Mouse events
//       document.addEventListener('mousemove', handlePointerMove);
//       document.addEventListener('mouseup', handlePointerUp);
//       // Touch events (passive: false to allow preventDefault for scroll prevention)
//       document.addEventListener('touchmove', handlePointerMove, {
//         passive: false,
//       });
//       document.addEventListener('touchend', handlePointerUp);
//       document.addEventListener('touchcancel', handlePointerUp);
//       return () => {
//         document.removeEventListener('mousemove', handlePointerMove);
//         document.removeEventListener('mouseup', handlePointerUp);
//         document.removeEventListener('touchmove', handlePointerMove);
//         document.removeEventListener('touchend', handlePointerUp);
//         document.removeEventListener('touchcancel', handlePointerUp);
//       };
//     }
//   }, [showDeviceModal, videoStream, handlePointerMove, handlePointerUp]);

//   // Enhanced video metrics tracking with ResizeObserver
//   const updateVideoMetrics = useCallback(() => {
//     const video = videoRef.current;
//     const container = videoContainerRef.current;
    
//     if (!video || !videoStream || !container) return;

//     if (video.videoWidth > 0 && video.videoHeight > 0) {
//       const containerRect = container.getBoundingClientRect();

//       // Calculate the actual rendered video dimensions within the container
//       const videoAspect = video.videoWidth / video.videoHeight;
//       const containerAspect = containerRect.width / containerRect.height;

//       let renderedWidth, renderedHeight, offsetX, offsetY;

//       if (containerAspect > videoAspect) {
//         // Container is wider - video will have black bars on left/right
//         renderedHeight = containerRect.height;
//         renderedWidth = renderedHeight * videoAspect;
//         offsetX = (containerRect.width - renderedWidth) / 2;
//         offsetY = 0;
//       } else {
//         // Container is taller - video will have black bars on top/bottom
//         renderedWidth = containerRect.width;
//         renderedHeight = renderedWidth / videoAspect;
//         offsetX = 0;
//         offsetY = (containerRect.height - renderedHeight) / 2;
//       }

//       const newMetrics = {
//         renderedWidth,
//         renderedHeight,
//         offsetX,
//         offsetY,
//         videoWidth: video.videoWidth,
//         videoHeight: video.videoHeight,
//         containerWidth: containerRect.width,
//         containerHeight: containerRect.height,
//       };

//       setVideoMetrics(newMetrics);

//       // Initialize crop box to reasonable default based on video size if not already set
//       // Only reset if this is the first time or if crop box is at default values
//       if (cropBox.width === 400 && cropBox.height === 300) {
//         const defaultCrop = {
//           x: Math.round(video.videoWidth * 0.1),
//           y: Math.round(video.videoHeight * 0.1),
//           width: Math.round(video.videoWidth * 0.8),
//           height: Math.round(video.videoHeight * 0.8),
//         };
//         setCropBox(defaultCrop);
//         setCropData(defaultCrop);
//       }
//     }
//   }, [videoStream, cropBox.width, cropBox.height]);

//   // Track video size and initialize crop box
//   useEffect(() => {
//     const video = videoRef.current;
//     const container = videoContainerRef.current;
    
//     if (!video || !videoStream || !container) return;

//     // Set up ResizeObserver for container size changes
//     if (resizeObserverRef.current) {
//       resizeObserverRef.current.disconnect();
//     }

//     resizeObserverRef.current = new ResizeObserver(() => {
//       // Debounce the update to avoid excessive calls
//       setTimeout(updateVideoMetrics, 100);
//     });

//     resizeObserverRef.current.observe(container);

//     video.addEventListener('loadedmetadata', updateVideoMetrics);
//     video.addEventListener('playing', updateVideoMetrics);
//     video.addEventListener('resize', updateVideoMetrics);
//     window.addEventListener('resize', updateVideoMetrics);

//     // Check immediately if video is already loaded
//     if (video.readyState >= 2) {
//       updateVideoMetrics();
//     }

//     return () => {
//       if (resizeObserverRef.current) {
//         resizeObserverRef.current.disconnect();
//       }
//       video.removeEventListener('loadedmetadata', updateVideoMetrics);
//       video.removeEventListener('playing', updateVideoMetrics);
//       video.removeEventListener('resize', updateVideoMetrics);
//       window.removeEventListener('resize', updateVideoMetrics);
//     };
//   }, [videoStream, updateVideoMetrics]);

//   useEffect(() => {
//     const performAutoSelection = async () => {
//       // Skip auto-selection if resetOnOpen is true (user clicked "New Crop")
//       if (
//         !autoSelect ||
//         hasAutoSelectedRef.current ||
//         !showDeviceModal ||
//         resetOnOpen
//       ) {
//         return;
//       }

//       hasAutoSelectedRef.current = true;

//       try {
//         console.log('[AutoSelect] Starting automatic feed selection...');

//         // Fetch machines to check if any exist
//         const machinesResponse = await apiClient.getUltrasoundMachines();
//         const machines = machinesResponse.data || [];

//         console.log('[AutoSelect] Found machines:', machines);

//         if (machines.length === 0) {
//           return;
//         }

//         console.log('[AutoSelect] Machines exist, auto-selecting...');
//         setIsAutoSelecting(true);
//         setAutoSelectError(null);

//         if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
//           const stream = await navigator.mediaDevices.getUserMedia({
//             video: true,
//             audio: true,
//           });
//           stream.getTracks().forEach((track) => track.stop());

//           const devices = await navigator.mediaDevices.enumerateDevices();
//           const videoDevices = devices.filter((device) => {
//             const label = device.label.toLowerCase();
//             // Exclude camera devices - keep capture cards and other video input devices
//             const isCameraDevice =
//               label.includes('camera') ||
//               label.includes('webcam') ||
//               label.includes('facetime') ||
//               label.includes('integrated') ||
//               label.includes('built-in') ||
//               label.includes('front') ||
//               label.includes('back') ||
//               label.includes('selfie') ||
//               label.includes('iphone') ||
//               label.includes('ipad') ||
//               label.includes('android');

//             return device.kind === 'videoinput' && !isCameraDevice;
//           });
//           setInputDevices(videoDevices);

//           console.log('[AutoSelect] Found USB devices:', videoDevices);

//           if (videoDevices.length === 0) {
//             setIsAutoSelecting(false);
//             return;
//           }

//           const firstDevice = videoDevices[0];
//           if (!firstDevice.deviceId || firstDevice.deviceId.trim() === '') {
//             setIsAutoSelecting(false);
//             return;
//           }

//           await autoSelectExistingMachine(machines[0], firstDevice.deviceId);
//         } else {
//           throw new Error('Media devices not supported');
//         }
//       } catch (error) {
//         console.error('[AutoSelect] Error during auto-selection:', error);
//         setAutoSelectError(error.message);
//         setIsAutoSelecting(false);
//       }
//     };

//     performAutoSelection();
//   }, [autoSelect, showDeviceModal, resetOnOpen]);

//   const autoSelectExistingMachine = async (machine, deviceId) => {
//     try {
//       const machineCropData = {
//         x: machine.crop_x,
//         y: machine.crop_y,
//         width: machine.crop_width,
//         height: machine.crop_height,
//       };
      
//       // Set both crop data and crop box to maintain consistency
//       setCropData(machineCropData);
//       setCropBox(machineCropData);

//       const updatedMachineConfig = {
//         ...machine,
//         crop_x: machineCropData.x,
//         crop_y: machineCropData.y,
//         crop_width: machineCropData.width,
//         crop_height: machineCropData.height,
//       };

//       setIsChecked(false);
//       setGlobalState((prev) => ({
//         ...prev,
//         optionValueDevice: 'USB',
//         deviceId: deviceId,
//         machineConfig: updatedMachineConfig,
//         isStart: false,
//         isVideoFrozen: true,
//       }));

//       await startVideoStream(deviceId, 'USB');

//       setIsAutoSelecting(false);
//       setShowDeviceModal(false);
//     } catch (error) {
//       console.error('[AutoSelect] Error in autoSelectExistingMachine:', error);
//       setAutoSelectError(error.message);
//       setIsAutoSelecting(false);
//     }
//   };

//   // Handle final submit - create new crop configuration and start exam
//   const handleFinalSubmit = async () => {
//     if (!cropData) {
//       alert('Please configure the crop area before continuing.');
//       return;
//     }

//     if (globalState.optionValueDevice === 'Share') {
//       setIsSaving(true);
//       try {
//         const screenShareConfig = {
//           id: 'screen-share-temp',
//           name: newMachineName || 'Screen Share',
//           crop_x: Math.round(cropData.x),
//           crop_y: Math.round(cropData.y),
//           crop_width: Math.round(cropData.width),
//           crop_height: Math.round(cropData.height),
//         };

//         setGlobalState((prevState) => ({
//           ...prevState,
//           machineConfig: screenShareConfig,
//           isStart: true,
//           isVideoFrozen: false,
//           deviceId: 'screen-share',
//         }));

//         setShowDeviceModal(false);
//         handleNext();
//       } catch (error) {
//         console.error('Failed to start screen share exam:', error);
//         alert('An error occurred while starting the exam.');
//       } finally {
//         setIsSaving(false);
//       }
//       return;
//     }

//     if (!newMachineName) {
//       alert('Please provide a configuration name.');
//       return;
//     }

//     setIsSaving(true);
//     try {
//       const payload = {
//         name: newMachineName,
//         crop_x: Math.round(cropData.x),
//         crop_y: Math.round(cropData.y),
//         crop_width: Math.round(cropData.width),
//         crop_height: Math.round(cropData.height),
//       };

//       const newMachine = await apiClient.createUltrasoundMachine(payload);
//       const machineConfigWithCrop = {
//         ...newMachine.data,
//         crop_x: Math.round(cropData.x),
//         crop_y: Math.round(cropData.y),
//         crop_width: Math.round(cropData.width),
//         crop_height: Math.round(cropData.height),
//       };

//       setGlobalState((prevState) => ({
//         ...prevState,
//         machineConfig: machineConfigWithCrop,
//         isStart: true,
//         isVideoFrozen: false,
//         deviceId: prevState.deviceId || 'screen-share',
//       }));

//       setShowDeviceModal(false);

//       handleNext();
//     } catch (error) {
//       console.error('Failed to create machine:', error);
//       alert('An error occurred while saving.');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   const isSubmitDisabled =
//     isSaving ||
//     !videoStream ||
//     !cropData ||
//     (globalState.optionValueDevice !== 'Share' && !newMachineName);
//   return (
//     <Modal
//       isOpen={showDeviceModal}
//       onClose={() => setShowDeviceModal(false)}
//       fullScreen={!!videoStream}
//       size={'5xl'}
//       className="bg-card-color-200 dark:bg-gray-900"
//     >
//       {/* HEADER: Slimmer padding when full screen */}
//       <div
//         className={`flex flex-row items-center justify-between border-b border-slate-200 dark:border-gray-700 gap-2 shrink-0 ${videoStream ? 'p-3' : 'p-4'}`}
//       >
//         <div className="flex flex-col">
//           <p className="text-lg font-bold bg-gradient-to-r from-blue-600 to-blue-800 dark:from-blue-400 dark:to-blue-600 bg-clip-text text-transparent">
//             DEEPECHO
//           </p>
//           <p className="text-xs text-gray-500 dark:text-gray-400">
//             {videoStream ? 'Configure Crop Area' : 'New Crop Configuration'}
//           </p>
//         </div>
//         <div className="flex items-center gap-3">
//           {globalState?.isConnected ? (
//             <div className="border rounded-full border-green-500 text-green-500 px-2 py-0.5 text-xs font-medium shadow-sm">
//               Connected
//             </div>
//           ) : (
//             <div className="border rounded-full border-red-500 text-red-500 px-2 py-0.5 text-xs font-medium shadow-sm">
//               Disconnected
//             </div>
//           )}
//           <Button variant="outline" onClick={handleStartOver} size="sm">
//             <RotateCcw className="w-4 h-4 mr-2" />
//             Reset
//           </Button>
//           <Button
//             onClick={handleFinalSubmit}
//             disabled={isSubmitDisabled}
//             size="sm"
//             className="min-w-[140px] shadow-lg shadow-blue-500/20"
//           >
//             {isSaving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
//             {isSaving ? 'Starting...' : 'Save'}
//           </Button>
//           <button
//             onClick={() => setShowDeviceModal(false)}
//             className="p-1.5 rounded-full text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
//           >
//             <X size={20} />
//           </button>
//         </div>
//       </div>

//       <Modal.Body
//         className={`flex-1 flex flex-col overflow-hidden ${videoStream ? 'p-2 sm:p-4' : 'p-6'}`}
//       >
//         {/* Step 1: Choose Feed Source */}
//         {!videoStream && (
//           <div className="space-y-4 max-w-2xl mx-auto w-full py-10">
//             <label className="block text-lg font-semibold text-gray-900 dark:text-white">
//               <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 text-sm font-bold mr-3">
//                 1
//               </span>
//               Choose Feed Source
//             </label>
//             <FeedSourceSelector
//               {...{
//                 selectedFeedSource,
//                 setSelectedFeedSource,
//                 showFeedDropdown,
//                 setShowFeedDropdown,
//                 inputDevices,
//                 setDeviceId,
//                 startVideoStream: (deviceId: string, optionValue: string) => {
//                   if (
//                     optionValue === 'USB' &&
//                     (!deviceId || deviceId.trim() === '')
//                   ) {
//                     console.error('Device ID is required for USB option');
//                     alert('Please select a valid camera device');
//                     return;
//                   }
//                   return startVideoStream(deviceId, optionValue);
//                 },
//                 setGlobalState,
//                 globalState,
//               }}
//             />
//           </div>
//         )}

//         {/* Step 2: Configure Crop (Full Screen Layout) */}
//         {videoStream && (
//           <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
//             {/* Video Preview: Now fills the entire remaining space */}
//             <div className="flex-1 relative rounded-xl bg-black shadow-2xl overflow-hidden border border-gray-800">
//               <div
//                 ref={videoContainerRef}
//                 className="w-full h-full relative flex items-center justify-center overflow-hidden"
//               >
//                 <video
//                   ref={videoRef}
//                   autoPlay
//                   playsInline
//                   muted
//                   className="max-w-full max-h-full object-contain"
//                 ></video>

//                 {/* Interactive Crop Box */}
//                 {videoRef.current &&
//                   videoRef.current.videoWidth > 0 &&
//                   cropBox.width > 0 &&
//                   videoContainerRef.current &&
//                   videoMetrics && (
//                     <div
//                       className={`absolute cursor-move touch-none z-10 ${
//                         isInteracting
//                           ? 'border-[3px] border-blue-500 bg-blue-500/10'
//                           : 'border-2 border-green-500 bg-green-500/5'
//                       }`}
//                       style={{
//                         left: `${videoMetrics.offsetX + (cropBox.x / videoRef.current.videoWidth) * videoMetrics.renderedWidth}px`,
//                         top: `${videoMetrics.offsetY + (cropBox.y / videoRef.current.videoHeight) * videoMetrics.renderedHeight}px`,
//                         width: `${(cropBox.width / videoRef.current.videoWidth) * videoMetrics.renderedWidth}px`,
//                         height: `${(cropBox.height / videoRef.current.videoHeight) * videoMetrics.renderedHeight}px`,
//                       }}
//                       onMouseDown={(e) => handlePointerDown(e, null)}
//                       onTouchStart={(e) => handlePointerDown(e, null)}
//                     >
//                       {/* Size Label */}
//                       <div className="absolute -top-8 left-0 bg-blue-600 text-white text-[10px] px-2 py-1 rounded">
//                         {Math.round(cropBox.width)} × {Math.round(cropBox.height)}
//                       </div>

//                       {/* Resize Handles (Circular, touch-friendly) */}
//                       {['nw', 'ne', 'sw', 'se'].map((pos) => (
//                         <div
//                           key={pos}
//                           className="absolute w-8 h-8 bg-white border-2 border-blue-500 rounded-full shadow-lg z-20"
//                           style={{
//                             top: pos.includes('n') ? '-16px' : 'auto',
//                             bottom: pos.includes('s') ? '-16px' : 'auto',
//                             left: pos.includes('w') ? '-16px' : 'auto',
//                             right: pos.includes('e') ? '-16px' : 'auto',
//                             cursor: `${pos}-resize`,
//                           }}
//                           onMouseDown={(e) => handlePointerDown(e, pos)}
//                           onTouchStart={(e) => handlePointerDown(e, pos)}
//                         />
//                       ))}

//                       {/* Edge resize zones - invisible but large touch targets */}
//                       {/* Top edge */}
//                       <div
//                         className="absolute touch-none"
//                         style={{
//                           top: '-20px',
//                           left: '32px',
//                           right: '32px',
//                           height: '40px',
//                           cursor: 'n-resize',
//                         }}
//                         onMouseDown={(e) => handlePointerDown(e, 'n')}
//                         onTouchStart={(e) => handlePointerDown(e, 'n')}
//                       />
//                       {/* Bottom edge */}
//                       <div
//                         className="absolute touch-none"
//                         style={{
//                           bottom: '-20px',
//                           left: '32px',
//                           right: '32px',
//                           height: '40px',
//                           cursor: 's-resize',
//                         }}
//                         onMouseDown={(e) => handlePointerDown(e, 's')}
//                         onTouchStart={(e) => handlePointerDown(e, 's')}
//                       />
//                       {/* Left edge */}
//                       <div
//                         className="absolute touch-none"
//                         style={{
//                           left: '-20px',
//                           top: '32px',
//                           bottom: '32px',
//                           width: '40px',
//                           cursor: 'w-resize',
//                         }}
//                         onMouseDown={(e) => handlePointerDown(e, 'w')}
//                         onTouchStart={(e) => handlePointerDown(e, 'w')}
//                       />
//                       {/* Right edge */}
//                       <div
//                         className="absolute touch-none"
//                         style={{
//                           right: '-20px',
//                           top: '32px',
//                           bottom: '32px',
//                           width: '40px',
//                           cursor: 'e-resize',
//                         }}
//                         onMouseDown={(e) => handlePointerDown(e, 'e')}
//                         onTouchStart={(e) => handlePointerDown(e, 'e')}
//                       />
//                     </div>
//                   )}
//               </div>
//             </div>
//           </div>
//         )}
//       </Modal.Body>

//       {/* Auto-selection loading overlay */}
//       {isAutoSelecting && (
//         <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm rounded-lg">
//           <div className="flex flex-col items-center gap-4 p-8">
//             <div className="relative">
//               <div className="absolute inset-0 blur-xl bg-blue-500 opacity-30 rounded-full"></div>
//               <Loader2 className="relative w-12 h-12 animate-spin text-blue-600 dark:text-blue-400" />
//             </div>
//             <div className="text-center space-y-2">
//               <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
//                 Setting up your exam...
//               </h3>
//               <p className="text-sm text-gray-600 dark:text-gray-400">
//                 Automatically configuring feed source
//               </p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Auto-selection error display */}
//       {autoSelectError && !isAutoSelecting && (
//         <div className="absolute top-16 sm:top-20 left-4 right-4 sm:left-1/2 sm:right-auto sm:transform sm:-translate-x-1/2 z-50 max-w-md mx-auto">
//           <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg sm:rounded-xl p-4 sm:p-5 shadow-xl">
//             <div className="flex items-start gap-3">
//               <div className="flex-shrink-0 mt-0.5">
//                 <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-red-100 dark:bg-red-900/40 flex items-center justify-center">
//                   <X className="w-4 h-4 sm:w-5 sm:h-5 text-red-600 dark:text-red-400" />
//                 </div>
//               </div>
//               <div className="flex-1 min-w-0">
//                 <h4 className="text-sm sm:text-base font-semibold text-red-800 dark:text-red-300">
//                   Auto-selection failed
//                 </h4>
//                 <p className="text-xs sm:text-sm text-red-700 dark:text-red-400 mt-1 break-words">
//                   {autoSelectError}
//                 </p>
//                 <p className="text-xs text-red-600 dark:text-red-500 mt-2">
//                   Please select your feed source manually below.
//                 </p>
//               </div>
//               <button
//                 onClick={() => setAutoSelectError(null)}
//                 className="flex-shrink-0 text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 transition-colors p-1"
//               >
//                 <X className="w-4 h-4" />
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </Modal>
//   );
// }

// export default StepperFeedRealtime;

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import '../../Pages/RealtimeInferencingPageV3/style/index.css';
import { APIClient } from '../../../helpers/apiHelper';
import FeedSourceSelector from '../FeedSourceSelector';
import { RotateCcw, X, Loader2 } from 'lucide-react';
import { RealtimeModal } from '../../ComponnentsUI/common/RealtimeModal';
import { messageI18n } from '../../../helpers/i18n/toastI18n';
import {
  FEED_SCREEN_SHARE,
  FEED_SOURCE_PLACEHOLDER,
} from '../../../helpers/i18n/realtimeFeedSource';

// --- HELPER COMPONENTS ---
const Button = ({
  children,
  onClick,
  disabled = false,
  variant = 'primary',
  size = 'md',
  className = '',
}) => {
  const baseClasses =
    'inline-flex items-center justify-center rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary:
      'bg-blue-600 dark:bg-blue-700 text-white hover:bg-blue-700 dark:hover:bg-blue-800 focus:ring-blue-500',
    outline:
      'border border-gray-300 dark:border-gray-600 bg-card-color-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 focus:ring-blue-500',
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
  };
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}
    >
      {children}
    </button>
  );
};

function StepperFeedRealtime({
  inputDevices,
  setDeviceId,
  setInputDevices,
  globalState,
  setGlobalState,
  mediaTypeSwitcher,
  handleNext,
  startVideoStream,
  setShowDeviceModal,
  showDeviceModal,
  videoStream,
  setVideoStream,
  autoSelect = false,
  resetOnOpen = false,
}) {
  const { t } = useTranslation('RealtimeExam');
  const [newMachineName, setNewMachineName] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [cropData, setCropData] = useState(null);
  const [selectedFeedSource, setSelectedFeedSource] = useState(
    FEED_SOURCE_PLACEHOLDER
  );
  const [showFeedDropdown, setShowFeedDropdown] = useState(false);
  const videoRef = useRef(null);
  const videoContainerRef = useRef(null);
  const apiClient = new APIClient();
  const [isChecked, setIsChecked] = useState(true);
  const [isAutoSelecting, setIsAutoSelecting] = useState(false);
  const [autoSelectError, setAutoSelectError] = useState(null);
  const hasAutoSelectedRef = useRef(false);

  // Video overlay cropping state
  const isDragging = useRef(false);
  const isResizing = useRef(false);
  const resizeHandle = useRef('');
  const dragStart = useRef({ x: 0, y: 0 });
  const [videoMetrics, setVideoMetrics] = useState(null);
  const [cropBox, setCropBox] = useState({
    x: 50,
    y: 50,
    width: 400,
    height: 300,
  });
  const [isInteracting, setIsInteracting] = useState(false);

  const handleStartOver = () => {
    setNewMachineName('');
    setIsSaving(false);
    setSelectedFeedSource(FEED_SOURCE_PLACEHOLDER);
    setCropData(null);
    setCropBox({ x: 50, y: 50, width: 400, height: 300 });
    setIsChecked(true);
    setShowFeedDropdown(false);
    setVideoMetrics(null);

    if (videoStream) {
      videoStream.getTracks().forEach((track) => track.stop());
      setVideoStream(null);
    }

    refreshInputDevices();
  };

  useEffect(() => {
    if (videoStream && videoRef.current) {
      videoRef.current.srcObject = videoStream;
    }
  }, [videoStream]);

  useEffect(() => {
    if (showDeviceModal && resetOnOpen) {
      setNewMachineName('');
      setIsSaving(false);
      setSelectedFeedSource(FEED_SOURCE_PLACEHOLDER);
      setCropData(null);
      setCropBox({ x: 50, y: 50, width: 400, height: 300 });
      setIsChecked(true);
      setShowFeedDropdown(false);
      setVideoMetrics(null);
      hasAutoSelectedRef.current = true;

      if (videoStream) {
        videoStream.getTracks().forEach((track) => track.stop());
        setVideoStream(null);
      }
    }
  }, [showDeviceModal, resetOnOpen]);

  useEffect(() => {
    if (showDeviceModal) {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ video: true, audio: true })
          .then((stream) => {
            stream.getTracks().forEach((track) => track.stop());
            return navigator.mediaDevices.enumerateDevices();
          })
          .then((devices) => {
            setInputDevices(
              devices.filter((device) => {
                const label = device.label.toLowerCase();
                // Exclude camera devices - keep capture cards and other video input devices
                const isCameraDevice =
                  label.includes('camera') ||
                  label.includes('webcam') ||
                  label.includes('facetime') ||
                  label.includes('integrated') ||
                  label.includes('built-in') ||
                  label.includes('front') ||
                  label.includes('back') ||
                  label.includes('selfie') ||
                  label.includes('iphone') ||
                  label.includes('ipad') ||
                  label.includes('android');

                return device.kind === 'videoinput' && !isCameraDevice;
              })
            );
          })
          .catch((err) => setInputDevices([]));
      }
    }
  }, [showDeviceModal, setInputDevices]);

  useEffect(() => {
    setGlobalState((prevState) => ({
      ...prevState,
      optionValueDevice: isChecked ? 'Share' : 'USB',
    }));
  }, [isChecked, setGlobalState]);

  useEffect(() => {
    if (
      selectedFeedSource &&
      selectedFeedSource !== FEED_SOURCE_PLACEHOLDER
    ) {
      setNewMachineName(selectedFeedSource);
    }
  }, [selectedFeedSource]);

  const refreshInputDevices = async () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true,
        });
        stream.getTracks().forEach((track) => track.stop());

        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter((device) => {
          const label = device.label.toLowerCase();
          // Exclude camera devices - keep capture cards and other video input devices
          const isCameraDevice =
            label.includes('camera') ||
            label.includes('webcam') ||
            label.includes('facetime') ||
            label.includes('integrated') ||
            label.includes('built-in') ||
            label.includes('front') ||
            label.includes('back') ||
            label.includes('selfie') ||
            label.includes('iphone') ||
            label.includes('ipad') ||
            label.includes('android');

          return device.kind === 'videoinput' && !isCameraDevice;
        });
        setInputDevices(videoDevices);
      } catch (err) {
        console.error('Failed to refresh input devices:', err);
        setInputDevices([]);
      }
    }
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    mediaTypeSwitcher();
  };

  const getEventCoordinates = useCallback((e) => {
    if ('touches' in e && e.touches.length > 0) {
      return { x: e.touches[0].clientX, y: e.touches[0].clientY };
    } else if ('changedTouches' in e && e.changedTouches.length > 0) {
      return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
    } else if ('clientX' in e) {
      return { x: e.clientX, y: e.clientY };
    }
    return { x: 0, y: 0 };
  }, []);

  // Convert from page coordinates to video coordinates
  const pageToVideoCoords = useCallback((pageX, pageY) => {
    if (!videoContainerRef.current || !videoRef.current || !videoMetrics) {
      return { x: 0, y: 0 };
    }

    const containerRect = videoContainerRef.current.getBoundingClientRect();
    
    // Position relative to container
    const relX = pageX - containerRect.left;
    const relY = pageY - containerRect.top;

    // Position relative to the rendered video (accounting for offsets)
    const videoRenderedX = relX - videoMetrics.offsetX;
    const videoRenderedY = relY - videoMetrics.offsetY;

    // Clamp to rendered video bounds
    const clampedX = Math.max(0, Math.min(videoRenderedX, videoMetrics.renderedWidth));
    const clampedY = Math.max(0, Math.min(videoRenderedY, videoMetrics.renderedHeight));

    // Convert to actual video coordinates
    const videoX = (clampedX / videoMetrics.renderedWidth) * videoRef.current.videoWidth;
    const videoY = (clampedY / videoMetrics.renderedHeight) * videoRef.current.videoHeight;

    return { 
      x: Math.round(videoX), 
      y: Math.round(videoY) 
    };
  }, [videoMetrics]);

  const handlePointerDown = useCallback((e, handle) => {
    e.preventDefault();
    e.stopPropagation();

    setIsInteracting(true);

    if (handle) {
      isResizing.current = true;
      resizeHandle.current = handle;
    } else {
      isDragging.current = true;
    }

    const coords = getEventCoordinates(e);
    const videoCoords = pageToVideoCoords(coords.x, coords.y);
    dragStart.current = {
      x: videoCoords.x,
      y: videoCoords.y,
    };
  }, [getEventCoordinates, pageToVideoCoords]);

  const handlePointerMove = useCallback(
    (e) => {
      if (!isDragging.current && !isResizing.current) return;
      if (!videoRef.current || !videoMetrics) return;

      if ('touches' in e) {
        e.preventDefault();
      }

      const video = videoRef.current;
      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;

      const coords = getEventCoordinates(e);
      const videoCoords = pageToVideoCoords(coords.x, coords.y);

      const deltaX = videoCoords.x - dragStart.current.x;
      const deltaY = videoCoords.y - dragStart.current.y;

      dragStart.current = { x: videoCoords.x, y: videoCoords.y };

      const minSize = 50;

      if (isDragging.current) {
        // Dragging - move the crop box
        setCropBox((prev) => {
          const newX = Math.max(0, Math.min(prev.x + deltaX, videoWidth - prev.width));
          const newY = Math.max(0, Math.min(prev.y + deltaY, videoHeight - prev.height));
          return { ...prev, x: newX, y: newY };
        });
      } else if (isResizing.current) {
        // Resizing - adjust crop box size with proper bounds
        setCropBox((prev) => {
          let { x, y, width, height } = prev;
          const handle = resizeHandle.current;

          // Store original positions to keep opposite edges fixed
          const rightEdge = x + width;
          const bottomEdge = y + height;

          // East edge - only change width (left edge stays fixed)
          if (handle === 'e' || handle.includes('e')) {
            const newWidth = width + deltaX;
            width = Math.max(minSize, Math.min(newWidth, videoWidth - x));
          }

          // West edge - only change x and width (right edge stays fixed)
          if (handle === 'w' || handle.includes('w')) {
            const newX = x + deltaX;
            if (newX >= 0 && rightEdge - newX >= minSize) {
              x = newX;
              width = rightEdge - newX;
            } else if (newX < 0) {
              x = 0;
              width = rightEdge;
            } else {
              // Hit minimum size - right edge stays fixed
              x = rightEdge - minSize;
              width = minSize;
            }
          }

          // South edge - only change height (top edge stays fixed)
          if (handle === 's' || handle.includes('s')) {
            const newHeight = height + deltaY;
            height = Math.max(minSize, Math.min(newHeight, videoHeight - y));
          }

          // North edge - only change y and height (bottom edge stays fixed)
          if (handle === 'n' || handle.includes('n')) {
            const newY = y + deltaY;
            if (newY >= 0 && bottomEdge - newY >= minSize) {
              y = newY;
              height = bottomEdge - newY;
            } else if (newY < 0) {
              y = 0;
              height = bottomEdge;
            } else {
              // Hit minimum size - bottom edge stays fixed
              y = bottomEdge - minSize;
              height = minSize;
            }
          }

          // Final safety clamp to ensure we're within bounds
          x = Math.max(0, Math.min(x, videoWidth - minSize));
          y = Math.max(0, Math.min(y, videoHeight - minSize));
          width = Math.max(minSize, Math.min(width, videoWidth - x));
          height = Math.max(minSize, Math.min(height, videoHeight - y));

          return { x, y, width, height };
        });
      }
    },
    [videoMetrics, getEventCoordinates, pageToVideoCoords]
  );

  const handlePointerUp = useCallback(() => {
    isDragging.current = false;
    isResizing.current = false;
    resizeHandle.current = '';
    setIsInteracting(false);
    setCropBox((currentCropBox) => {
      setCropData({
        x: Math.round(currentCropBox.x),
        y: Math.round(currentCropBox.y),
        width: Math.round(currentCropBox.width),
        height: Math.round(currentCropBox.height),
      });
      return currentCropBox;
    });
  }, []);

  useEffect(() => {
    if (showDeviceModal && videoStream) {
      // Mouse events
      document.addEventListener('mousemove', handlePointerMove);
      document.addEventListener('mouseup', handlePointerUp);
      // Touch events (passive: false to allow preventDefault for scroll prevention)
      document.addEventListener('touchmove', handlePointerMove, { passive: false });
      document.addEventListener('touchend', handlePointerUp);
      document.addEventListener('touchcancel', handlePointerUp);
      return () => {
        document.removeEventListener('mousemove', handlePointerMove);
        document.removeEventListener('mouseup', handlePointerUp);
        document.removeEventListener('touchmove', handlePointerMove);
        document.removeEventListener('touchend', handlePointerUp);
        document.removeEventListener('touchcancel', handlePointerUp);
      };
    }
  }, [showDeviceModal, videoStream, handlePointerMove, handlePointerUp]);

  // Track video size and initialize crop box
  useEffect(() => {
    const video = videoRef.current;
    if (!video || !videoStream) return;

    const updateVideoMetrics = () => {
      if (
        video.videoWidth > 0 &&
        video.videoHeight > 0 &&
        videoContainerRef.current
      ) {
        const containerRect = videoContainerRef.current.getBoundingClientRect();

        // Calculate the actual rendered video dimensions within the container
        const videoAspect = video.videoWidth / video.videoHeight;
        const containerAspect = containerRect.width / containerRect.height;

        let renderedWidth, renderedHeight, offsetX, offsetY;

        if (containerAspect > videoAspect) {
          // Container is wider - video will have black bars on left/right
          renderedHeight = containerRect.height;
          renderedWidth = renderedHeight * videoAspect;
          offsetX = (containerRect.width - renderedWidth) / 2;
          offsetY = 0;
        } else {
          // Container is taller - video will have black bars on top/bottom
          renderedWidth = containerRect.width;
          renderedHeight = renderedWidth / videoAspect;
          offsetX = 0;
          offsetY = (containerRect.height - renderedHeight) / 2;
        }

        setVideoMetrics({
          renderedWidth,
          renderedHeight,
          offsetX,
          offsetY,
        });

        // Initialize crop box to reasonable default based on video size if not already set
        if (cropBox.width === 400) {
          const defaultCrop = {
            x: Math.round(video.videoWidth * 0.1),
            y: Math.round(video.videoHeight * 0.1),
            width: Math.round(video.videoWidth * 0.8),
            height: Math.round(video.videoHeight * 0.8),
          };
          setCropBox(defaultCrop);
          setCropData(defaultCrop);
        }
      }
    };

    video.addEventListener('loadedmetadata', updateVideoMetrics);
    video.addEventListener('playing', updateVideoMetrics);
    const resizeObserver = new ResizeObserver(updateVideoMetrics);
    resizeObserver.observe(videoContainerRef.current);

    // Check immediately if video is already loaded
    if (video.readyState >= 2) {
      updateVideoMetrics();
    }

    return () => {
      video.removeEventListener('loadedmetadata', updateVideoMetrics);
      video.removeEventListener('playing', updateVideoMetrics);
      resizeObserver.disconnect();
    };
  }, [videoStream, cropBox.width]);

  useEffect(() => {
    const performAutoSelection = async () => {
      // Skip auto-selection if resetOnOpen is true (user clicked "New Crop")
      if (
        !autoSelect ||
        hasAutoSelectedRef.current ||
        !showDeviceModal ||
        resetOnOpen
      ) {
        return;
      }

      hasAutoSelectedRef.current = true;

      try {
        console.log('[AutoSelect] Starting automatic feed selection...');

        // Fetch machines to check if any exist
        const machinesResponse = await apiClient.getUltrasoundMachines();
        const machines = machinesResponse.data || [];

        console.log('[AutoSelect] Found machines:', machines);

        if (machines.length === 0) {
          return;
        }

        console.log('[AutoSelect] Machines exist, auto-selecting...');
        setIsAutoSelecting(true);
        setAutoSelectError(null);

        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: true,
            audio: true,
          });
          stream.getTracks().forEach((track) => track.stop());

          const devices = await navigator.mediaDevices.enumerateDevices();
          const videoDevices = devices.filter((device) => {
            const label = device.label.toLowerCase();
            // Exclude camera devices - keep capture cards and other video input devices
            const isCameraDevice =
              label.includes('camera') ||
              label.includes('webcam') ||
              label.includes('facetime') ||
              label.includes('integrated') ||
              label.includes('built-in') ||
              label.includes('front') ||
              label.includes('back') ||
              label.includes('selfie') ||
              label.includes('iphone') ||
              label.includes('ipad') ||
              label.includes('android');

            return device.kind === 'videoinput' && !isCameraDevice;
          });
          setInputDevices(videoDevices);

          console.log('[AutoSelect] Found USB devices:', videoDevices);

          if (videoDevices.length === 0) {
            setIsAutoSelecting(false);
            return;
          }

          const firstDevice = videoDevices[0];
          if (!firstDevice.deviceId || firstDevice.deviceId.trim() === '') {
            setIsAutoSelecting(false);
            return;
          }

          await autoSelectExistingMachine(machines[0], firstDevice.deviceId);
        } else {
          throw new Error('Media devices not supported');
        }
      } catch (error) {
        console.error('[AutoSelect] Error during auto-selection:', error);
        setAutoSelectError(error.message);
        setIsAutoSelecting(false);
      }
    };

    performAutoSelection();
  }, [autoSelect, showDeviceModal, resetOnOpen]);

  const autoSelectExistingMachine = async (machine, deviceId) => {
    try {

      const machineCropData = {
        x: machine.crop_x,
        y: machine.crop_y,
        width: machine.crop_width,
        height: machine.crop_height,
      };
      setCropData(machineCropData);

      const updatedMachineConfig = {
        ...machine,
        crop_x: machineCropData.x,
        crop_y: machineCropData.y,
        crop_width: machineCropData.width,
        crop_height: machineCropData.height,
      };

      setIsChecked(false);
      setGlobalState((prev) => ({
        ...prev,
        optionValueDevice: 'USB',
        deviceId: deviceId,
        machineConfig: updatedMachineConfig,
        isStart: false,
        isVideoFrozen: true,
      }));

      await startVideoStream(deviceId, 'USB');

      setIsAutoSelecting(false);
      setShowDeviceModal(false);
    } catch (error) {
      console.error('[AutoSelect] Error in autoSelectExistingMachine:', error);
      setAutoSelectError(error.message);
      setIsAutoSelecting(false);
    }
  };

  // Handle final submit - create new crop configuration and start exam
  const handleFinalSubmit = async () => {
    if (!cropData) {
      messageI18n.warning('crop.configureAreaFirst');
      return;
    }

    if (globalState.optionValueDevice === 'Share') {
      setIsSaving(true);
      try {
        const screenShareConfig = {
          id: 'screen-share-temp',
          name: newMachineName || FEED_SCREEN_SHARE,
          crop_x: Math.round(cropData.x),
          crop_y: Math.round(cropData.y),
          crop_width: Math.round(cropData.width),
          crop_height: Math.round(cropData.height),
        };

        setGlobalState((prevState) => ({
          ...prevState,
          machineConfig: screenShareConfig,
          isStart: true,
          isVideoFrozen: false,
          deviceId: 'screen-share',
        }));

        setShowDeviceModal(false);
        handleNext();
      } catch (error) {
        console.error('Failed to start screen share exam:', error);
        messageI18n.error('crop.examStartFailed');
      } finally {
        setIsSaving(false);
      }
      return;
    }

    if (!newMachineName) {
      messageI18n.warning('crop.configurationNameRequired');
      return;
    }

    setIsSaving(true);
    try {
      const payload = {
        name: newMachineName,
        crop_x: Math.round(cropData.x),
        crop_y: Math.round(cropData.y),
        crop_width: Math.round(cropData.width),
        crop_height: Math.round(cropData.height),
      };

      const newMachine = await apiClient.createUltrasoundMachine(payload);
      const machineConfigWithCrop = {
        ...newMachine.data,
        crop_x: Math.round(cropData.x),
        crop_y: Math.round(cropData.y),
        crop_width: Math.round(cropData.width),
        crop_height: Math.round(cropData.height),
      };

      setGlobalState((prevState) => ({
        ...prevState,
        machineConfig: machineConfigWithCrop,
        isStart: true,
        isVideoFrozen: false,
        deviceId: prevState.deviceId || 'screen-share',
      }));

      setShowDeviceModal(false);

      handleNext();
    } catch (error) {
      console.error('Failed to create machine:', error);
      messageI18n.error('crop.saveFailed');
    } finally {
      setIsSaving(false);
    }
  };

  const isSubmitDisabled =
    isSaving ||
    !videoStream ||
    !cropData ||
    (globalState.optionValueDevice !== 'Share' && !newMachineName);
  
  return (
    <RealtimeModal
      isOpen={showDeviceModal}
      onClose={() => setShowDeviceModal(false)}
      fullScreen={!!videoStream}
      size={'5xl'}
      className="bg-card-color-200 dark:bg-gray-900"
    >
      {/* HEADER: Slimmer padding when full screen */}
      <div
        className={`flex flex-row items-center justify-between border-b border-slate-200 dark:border-gray-700 gap-2 shrink-0 ${videoStream ? 'p-3' : 'p-4'}`}
      >
        <div className="flex flex-col">
          <p className="text-lg font-bold bg-gradient-to-r from-blue-600 to-blue-800 dark:from-blue-400 dark:to-blue-600 bg-clip-text text-transparent">
            DEEPECHO
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {videoStream
              ? t('cropModal.configureCropArea')
              : t('cropModal.newCropConfiguration')}
          </p>
        </div>
        <div className="flex items-center gap-3">
          {globalState?.isConnected ? (
            <div className="border rounded-full border-green-500 text-green-500 px-2 py-0.5 text-xs font-medium shadow-sm">
              {t('status.connected')}
            </div>
          ) : (
            <div className="border rounded-full border-red-500 text-red-500 px-2 py-0.5 text-xs font-medium shadow-sm">
              {t('status.disconnected')}
            </div>
          )}
          <Button
            variant="outline"
            onClick={handleStartOver}
            size="sm"
          >
            <RotateCcw className="w-4 h-4 mr-2" />
            {t('cropModal.reset')}
          </Button>
          <Button
            onClick={handleFinalSubmit}
            disabled={isSubmitDisabled}
            size="sm"
            className="min-w-[140px] shadow-lg shadow-blue-500/20"
          >
            {isSaving && (
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            )}
            {isSaving ? t('cropModal.starting') : t('cropModal.save')}
          </Button>
          <button
            onClick={() => setShowDeviceModal(false)}
            className="p-1.5 rounded-full text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          >
            <X size={20} />
          </button>
        </div>
      </div>

      <RealtimeModal.Body
        className={`flex-1 flex flex-col overflow-hidden ${videoStream ? 'p-2 sm:p-4' : 'p-6'}`}
      >
        {/* Step 1: Choose Feed Source */}
        {!videoStream && (
          <div className="space-y-4 max-w-2xl mx-auto w-full py-10">
            <label className="block text-lg font-semibold text-gray-900 dark:text-white">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 text-sm font-bold mr-3">
                1
              </span>
              {t('cropModal.chooseFeedSourceStep')}
            </label>
            <FeedSourceSelector
              {...{
                selectedFeedSource,
                setSelectedFeedSource,
                showFeedDropdown,
                setShowFeedDropdown,
                inputDevices,
                setDeviceId,
                startVideoStream: (deviceId, optionValue) => {
                  if (
                    optionValue === 'USB' &&
                    (!deviceId || deviceId.trim() === '')
                  ) {
                    console.error('Device ID is required for USB option');
                    messageI18n.error('crop.selectValidCamera');
                    return;
                  }
                  return startVideoStream(deviceId, optionValue);
                },
                setGlobalState,
                globalState,
              }}
            />
          </div>
        )}

        {/* Step 2: Configure Crop (Full Screen Layout) */}
        {videoStream && (
          <>
              <div ref={videoContainerRef} className="w-full h-full relative flex items-center justify-center overflow-hidden">
                <video
                  ref={videoRef}
                  autoPlay
                  playsInline
                  muted
                  className="w-full h-full object-contain"
                ></video>

                {/* Interactive Crop Box */}
                {videoRef.current &&
                  videoRef.current.videoWidth > 0 &&
                  cropBox.width > 0 &&
                  videoContainerRef.current &&
                  videoMetrics && (
                    <div
                      className={`absolute cursor-move touch-none z-10 ${
                        isInteracting
                          ? 'border-[3px] border-blue-500 bg-blue-500/10'
                          : 'border-2 border-green-500 bg-green-500/5'
                      }`}
                      style={{
                        left: `${videoMetrics.offsetX + (cropBox.x / videoRef.current.videoWidth) * videoMetrics.renderedWidth}px`,
                        top: `${videoMetrics.offsetY + (cropBox.y / videoRef.current.videoHeight) * videoMetrics.renderedHeight}px`,
                        width: `${(cropBox.width / videoRef.current.videoWidth) * videoMetrics.renderedWidth}px`,
                        height: `${(cropBox.height / videoRef.current.videoHeight) * videoMetrics.renderedHeight}px`,
                      }}
                      onMouseDown={(e) => handlePointerDown(e, null)}
                      onTouchStart={(e) => handlePointerDown(e, null)}
                    >
                      {/* Size Label */}
                      <div className="absolute -top-8 left-0 bg-blue-600 text-white text-[10px] px-2 py-1 rounded">
                        {Math.round(cropBox.width)} × {Math.round(cropBox.height)}
                      </div>

                      {/* Resize Handles (Circular, touch-friendly) */}
                      {['nw', 'ne', 'sw', 'se'].map((pos) => (
                        <div
                          key={pos}
                          className="absolute w-8 h-8 bg-white border-2 border-blue-500 rounded-full shadow-lg z-20"
                          style={{
                            top: pos.includes('n') ? '-16px' : 'auto',
                            bottom: pos.includes('s') ? '-16px' : 'auto',
                            left: pos.includes('w') ? '-16px' : 'auto',
                            right: pos.includes('e') ? '-16px' : 'auto',
                            cursor: `${pos}-resize`,
                          }}
                          onMouseDown={(e) => handlePointerDown(e, pos)}
                          onTouchStart={(e) => handlePointerDown(e, pos)}
                        />
                      ))}

                      {/* Edge resize zones - invisible but large touch targets */}
                      {/* Top edge */}
                      <div
                        className="absolute touch-none"
                        style={{
                          top: '-20px',
                          left: '32px',
                          right: '32px',
                          height: '40px',
                          cursor: 'n-resize',
                        }}
                        onMouseDown={(e) => handlePointerDown(e, 'n')}
                        onTouchStart={(e) => handlePointerDown(e, 'n')}
                      />
                      {/* Bottom edge */}
                      <div
                        className="absolute touch-none"
                        style={{
                          bottom: '-20px',
                          left: '32px',
                          right: '32px',
                          height: '40px',
                          cursor: 's-resize',
                        }}
                        onMouseDown={(e) => handlePointerDown(e, 's')}
                        onTouchStart={(e) => handlePointerDown(e, 's')}
                      />
                      {/* Left edge */}
                      <div
                        className="absolute touch-none"
                        style={{
                          left: '-20px',
                          top: '32px',
                          bottom: '32px',
                          width: '40px',
                          cursor: 'w-resize',
                        }}
                        onMouseDown={(e) => handlePointerDown(e, 'w')}
                        onTouchStart={(e) => handlePointerDown(e, 'w')}
                      />
                      {/* Right edge */}
                      <div
                        className="absolute touch-none"
                        style={{
                          right: '-20px',
                          top: '32px',
                          bottom: '32px',
                          width: '40px',
                          cursor: 'e-resize',
                        }}
                        onMouseDown={(e) => handlePointerDown(e, 'e')}
                        onTouchStart={(e) => handlePointerDown(e, 'e')}
                      />
                    </div>
                  )}
              </div>
              </>
        )}
      </RealtimeModal.Body>

      {/* Auto-selection loading overlay */}
      {isAutoSelecting && (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm rounded-lg">
          <div className="flex flex-col items-center gap-4 p-8">
            <div className="relative">
              <div className="absolute inset-0 blur-xl bg-blue-500 opacity-30 rounded-full"></div>
              <Loader2 className="relative w-12 h-12 animate-spin text-blue-600 dark:text-blue-400" />
            </div>
            <div className="text-center space-y-2">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                {t('cropModal.settingUpExam')}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {t('cropModal.autoConfiguringFeed')}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Auto-selection error display */}
      {autoSelectError && !isAutoSelecting && (
        <div className="absolute top-16 sm:top-20 left-4 right-4 sm:left-1/2 sm:right-auto sm:transform sm:-translate-x-1/2 z-50 max-w-md mx-auto">
          <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg sm:rounded-xl p-4 sm:p-5 shadow-xl">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 mt-0.5">
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-red-100 dark:bg-red-900/40 flex items-center justify-center">
                  <X className="w-4 h-4 sm:w-5 sm:h-5 text-red-600 dark:text-red-400" />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm sm:text-base font-semibold text-red-800 dark:text-red-300">
                  {t('cropModal.autoSelectionFailed')}
                </h4>
                <p className="text-xs sm:text-sm text-red-700 dark:text-red-400 mt-1 break-words">
                  {autoSelectError}
                </p>
                <p className="text-xs text-red-600 dark:text-red-500 mt-2">
                  {t('cropModal.selectFeedManually')}
                </p>
              </div>
              <button
                onClick={() => setAutoSelectError(null)}
                className="flex-shrink-0 text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 transition-colors p-1"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      )}
    </RealtimeModal>
  );
}

export default StepperFeedRealtime;